// extracted by mini-css-extract-plugin
export default {"main":"HomePageCandidate_main__MC-hR","content":"HomePageCandidate_content__XvRhy"};